import { DEFAULT_CURSOR as m, DEFAULT_POSITION as f, DEFAULT_SIZE as d } from "./styles.js";
function z(t) {
  const { clientX: c, clientY: s } = t;
  return { clientX: c, clientY: s };
}
function y(t, c) {
  const { clientX: s, clientY: r } = t, { left: n, top: o, width: e, height: i } = c, l = s - (n - 1), u = r - (o - 1), a = l / e * 100, g = u / i * 100;
  return { zoomX: a, zoomY: g };
}
function b() {
  let t = !1;
  const c = (n) => {
    n.preventDefault();
    const o = n.currentTarget, e = o.getBoundingClientRect(), i = z(n), { zoomX: l, zoomY: u } = y(i, e);
    o.style.backgroundPosition = `${l}% ${u}%`;
  };
  function s(n) {
    t = !t;
    const o = t ? 300 : 150, e = n.currentTarget;
    e.style.backgroundSize = `${o}%`, e.style.cursor = t ? "zoom-out" : m;
  }
  function r(n) {
    t = !1;
    const o = n.currentTarget;
    o.style.cursor = m, o.style.backgroundPosition = f, o.style.backgroundSize = d;
  }
  return { moveZoom: c, addZoom: s, clear: r };
}
export {
  z as getPositions,
  y as getZoomPosition,
  b as zoomFilters
};
